/**
 * Product Form Components
 *
 */
optionName='';
variantFound = false;
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
   if (this.form) {
   this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
   }
    this.cartElement = document.querySelector('ajax-cart');
    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  _getSelectedVariantFromForm() {
    const selects = this.querySelectorAll('variant-selects .variant_selector');
    if (!selects.length) {
      return { variant: null, requiresSelection: false, optionName: '' };
    }

    const selectedOptions = Array.from(selects).map((selector) => selector.value);
    const optionName = (selects[0].getAttribute('name') || '')
      .replace(/^options\[/, '')
      .replace(/\]$/, '') || 'option';
    let variants = [];
    const jsonEl = this.querySelector('[data-variantJSON]');
    try {
      variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    } catch (err) {
      variants = [];
    }

    const variant = variants.find((item) => (
      Array.isArray(item.options)
      && item.options.length === selectedOptions.length
      && item.options.every((option, index) => option === selectedOptions[index])
    ));

    return { variant: variant || null, requiresSelection: true, optionName };
  }

  async onSubmitHandler(evt) {
    evt.preventDefault();
    const addItems = [];
    const giftItem = [];
    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector('[data-qty-input]');
    const pdpContainer = this.closest('.product-details-wrapper');
    if (!submitButton) return;

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const selectedVariant = this._getSelectedVariantFromForm();
    if (selectedVariant.requiresSelection && !selectedVariant.variant) {
      const attributName = selectedVariant.optionName
        || submitButton.querySelector(".add-text")?.getAttribute('optiontype')
        || 'option';
      if (window.notificationEle && typeof window.notificationEle.updateNotification === 'function') {
        window.notificationEle.updateNotification('Cart Error', `Select a ${attributName} first`, {
          type: 'error',
          timeout: 3000
        });
      }
      submitButton.removeAttribute('disabled');
      submitButton.classList.remove('loading');
      return false;
    }
    if (selectedVariant.variant) {
      const idInput = this.form.querySelector('input[name="id"]');
      if (idInput) idInput.value = selectedVariant.variant.id;
    }
    
    let price;
    const gridParent = evt.currentTarget.closest("[data-product-grid]");
    const pdpParent = evt.currentTarget.closest("[data-product-container]");
    if (gridParent) {
      const priceEl = gridParent.querySelector('[data-currentprice]');
      if (priceEl) price = priceEl.innerHTML;
    } else if (pdpParent) {
      const priceEl = pdpParent.querySelector('[data-currentprice]');
      if (priceEl) price = priceEl.innerHTML;
    }

 
    // ----------------- for free gift with the one time products -----------------
    let isProductEligibleForPromo = evt.currentTarget.closest("product-form").querySelector('[data-promoScript]');

    if(isProductEligibleForPromo && isProductEligibleForPromo != null){ 
      let promoProduct = document.getElementById("promo-gift");
      let promoProductId = promoProduct.getAttribute("data-promo-gift-variant-id");

      let giftProperty = {};
      giftProperty['_promoGiftProduct']='true';
      giftProperty['_main_product_auto_renew_id'] = JSON.parse(serializeForm(this.form)).id;

      giftItem.push( {
        quantity: 1,
        id: parseInt(promoProductId),
        properties : giftProperty
      });

      await fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: giftItem
        })
      }).then((res)=>res.json())
    }

    // ---------------------------------------------------
   
    if (typeof ttq !== 'undefined' && ttq && typeof ttq.track === 'function') {
      const serializedForm = JSON.parse(serializeForm(this.form));
      ttq.track('AddToCart',{
        content_id: serializedForm.id,
        quantity: serializedForm.quantity,
        value: price,
        currency: 'USD',
      });
    }
    // const selectCrateElement = document.getElementById("Option-crate");
    // const selectedCrateOption = selectCrateElement.value;

    // const selectElement = document.querySelector('select[name="options[Size]"]');
    // const selectedOption = selectElement?.value;
    // const proCratePriceScript = document.querySelector('script[data-ProCrate]');
    // if (proCratePriceScript && selectElement && selectedCrateOption.toLowerCase() === 'platecrate pro'){
    //   const parsedPrices = JSON.parse(proCratePriceScript.textContent);
    //   const match = parsedPrices.find(p => p.pro_crate_option == selectedOption);
    //   const formData = JSON.parse(serializeForm(this.form));
    //   if (match) {
    //     formData.id = match.variant_id; // Replace form variant ID
    //   }
    //   addItems.push(formData);
    // }else{
    //   addItems.push(JSON.parse(serializeForm(this.form)))
    // }


      const selectCrateElement = document.getElementById("Option-crate");
      const selectedCrateOption = selectCrateElement?.value;
      
      const selectElement = document.querySelector('select[name="options[Size]"]');
      const selectedOption = selectElement?.value;
      
      const proCratePriceScript = document.querySelector('script[data-ProCrate]');
      
      if (
        proCratePriceScript &&
        selectCrateElement &&
        selectElement &&
        selectedCrateOption?.toLowerCase() === 'platecrate pro'
      ) {
        try {
          const parsedPrices = JSON.parse(proCratePriceScript.textContent);
          const match = parsedPrices.find(p => p.pro_crate_option === selectedOption);
          const formData = JSON.parse(serializeForm(this.form));
      
          if (match) {
            formData.id = match.variant_id; // Replace form variant ID
          }
      
          addItems.push(formData);
        } catch (err) {
          console.error("Error parsing ProCrate data or serializing form:", err);
        }
      } else {
        try {
          const formData = JSON.parse(serializeForm(this.form));
          addItems.push(formData);
        } catch (err) {
          console.error("Error serializing form:", err);
        }
      }


    
    if(pdpContainer){
      let addOnItemsEle = pdpContainer.querySelectorAll('[data-addon-selection]:checked');
      addOnItemsEle.forEach((addOn)=>{
        if(!addOn.disabled){
          let addOnParent = addOn.closest('addons-form');
          let addOnJSON = {
            id: addOnParent.querySelector('.variant--id').value,
            quantity: addOnParent.querySelector('.product-quantity').value
          }
          addItems.push(addOnJSON);
        }
      });
    }

    const body = JSON.stringify({
      items: addItems
    });
    await fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then(() => {
        if(document.querySelector('#PopupModal-quickshop')){
          document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
        }
        //this.cartElement.getCartData('open_drawer');
        window.location.href = "/cart";
        if(qtyInput) qtyInput.value = 1;
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
      });
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;
    let decreaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="decrease"]');

    if(action == 'decrease' && currentQty <= 1){
      if(decreaseQtyBtn) decreaseQtyBtn.classList.add('disabled');
      return false;
    }else if(action == 'decrease'){
      finalQty = currentQty - 1;
      finalQty == 1 ? decreaseQtyBtn.classList.add('disabled') : decreaseQtyBtn.classList.remove('disabled');
    }else{
      if(decreaseQtyBtn) decreaseQtyBtn.classList.remove('disabled');
      finalQty = currentQty + 1;
    }

    $qtyInput.value = finalQty;
  }
}
customElements.define('product-form', ProductForm);

/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;

    if(this.formType == 'product-page') this.onVariantChange('load');
    this.addEventListener('change', this.onVariantChange.bind(this));
    this.init()
  }

  // init(){
  //   document.addEventListener('DOMContentLoaded', function() {
  //     const crateDropdown = document.querySelector('[data-crate-dropdown]');
  //     const hiddenInput = document.querySelector('[data-crate-type]');
  //     crateDropdown.addEventListener('change', function() {
  //       const selectedValue = this.value;
  //       hiddenInput.setAttribute('data-crate-type', selectedValue);
  //       hiddenInput.value = selectedValue.toLowerCase();
  //       const productPage = this.closest('[data-product-container]');
  //       this.updateProductPrice(this.currentVariant, productPage)
  //       //document.querySelector("[data-atc-btn]")?.classList.remove("disabled");
  //     });
  //     // document.querySelector("[data-atc-btn]")?.classList.add("disabled");
  //     // const initialValue = crateDropdown.value;
  //     // {% comment %} hiddenInput.setAttribute('data-ctate-type', initialValue); {% endcomment %}
  //     // hiddenInput.value = initialValue.toLowerCase(); // or just initialValue
  //   });
  // }
  init() {
    const crateDropdown = document.querySelector('[data-crate-dropdown]');
    const hiddenInput = document.querySelector('[data-crate-type]');
      if (crateDropdown) {
    crateDropdown.addEventListener('change', () => {
      const selectedValue = crateDropdown.value;
      hiddenInput.setAttribute('data-crate-type', selectedValue);
      hiddenInput.value = selectedValue.toLowerCase();
      const proElement = document.querySelector('[data_crate="pro"]');
      const classicElement = document.querySelector('[data_crate="classic"]');

      if (selectedValue.toLowerCase() === 'platecrate pro') {
        if (proElement) {
          proElement.classList.remove('d-none');
        }
        if (classicElement) {
          classicElement.classList.add('d-none');
        }
      } else {
        if (proElement) {
          proElement.classList.add('d-none');
        }
        if (classicElement) {
          classicElement.classList.remove('d-none');
        }
      }
      const productPage = crateDropdown.closest('[data-product-container]');
      this.updateProductPrice(this.currentVariant, productPage);
    });
      }
  }


  /**
   * Trigger this function variant is changed
   * @param {event} _event 
   */
  onVariantChange(_event) {
    if(window.globalVariables.templateSuffix !='catapult-landing'){
    this.setCurrentVariant();
    }
    if(this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;


    if (this.formType == 'grid' || window.globalVariables.template == 'collection') {
      const addText = this.form && this.form.querySelector(".add-text");
      if (addText) {
        if (!this.currentVariant) {
          const selector = this.querySelector('.variant_selector');
          optionName = selector ? selector.value : '';
          variantFound = false;
          addText.setAttribute("optionType", optionName || addText.getAttribute("optionType") || 'option');
        } else {
          optionName = '';
          variantFound = true;
          addText.removeAttribute("optionType");
        }
      }
    }

    if (!this.currentVariant) {
      this.toggleAddButton('disable');
      // Variant name update
      let options = this.form.querySelectorAll('[data-optionindex]');
      options.forEach(option => {
        let lableID = 'option'+option.dataset.optionindex;
        const selectedValue = option.querySelector('input[type="radio"]:checked');
        const lable = option.querySelector('.selected-option');
        if(!lable || !lableID || !selectedValue) return;
        lable.innerHTML = selectedValue.value;
      });
    } else {
      if(this.formType == 'grid'){
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid); 
      }else{
        const productPage = this.closest('[data-product-container]');
        this.renderProductInfo(this.currentVariant, productPage);
      }
      this.updateURLandID(this.currentVariant);
      this.toggleAddButton('enable');
    }
  }

  /**
   * Change product variant url link in product card when variant is being updated
   * @param {element} productGrid 
   */
  _updateLinks(productGrid){
    if(!this.currentVariant || !productGrid) return;
    const variantURL = '?variant=' + this.currentVariant.id;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  /**
   * Fetch selected options from dropdown
   */
  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector)=>{
      options.push(selector.value);
    });
    return options;
  }

  /**
   * Fetch selected options from radio
   */
  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    return fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked).value;
    });
  }

  /**
   * change value of currentVariant when variant being changed 
   */
  setCurrentVariant() {
    // get all current values from selectors
    this.currentVariant = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      // get true or false based on options value presented in variant
      // value format would be [true/false,true/fasle,true/false] boolean value based on options present or not
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      // assign variant details to this.currentVariant if all options are present
      if(!mappedValues.includes(false)){
        this.currentVariant = variant;
      }
    });
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant 
   */
  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    // update query string with latest variant ID
    if(this.formType == 'product-page') window.history.replaceState({ }, '', `${this.dataset.url}?variant=${currentVariant.id}`);

    // update variant input with currentVariant Id
    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  /**
   * Render Product data based on current variant
   * @param {event} currentVariant 
   * @param {element} container 
   */
  renderProductInfo(currentVariant, container) {
    if(!currentVariant || !container) return;

    this.updateProductPrice(currentVariant,container);

    // Grid Image Update on variant selection
    if(this.formType == 'grid'){
      if(!currentVariant.featured_image) return;
      const featuredImage = container.querySelector('[data-feauredImage]');
      let updatedSrc = currentVariant.featured_image.src;
      if(featuredImage && updatedSrc){
        featuredImage.src = updatedSrc;
        featuredImage.srcset = updatedSrc;
      }
    }else{
      if(!currentVariant.featured_image) return;
      let imageID = currentVariant.featured_media.id;
      let imageSlide = document.querySelector(`.product--media[data-mediaID="${imageID}"]`);
      if(this.formType == 'quickshop'){
        imageSlide = document.querySelector(`.quickshop-slider .product--media[data-mediaID="${imageID}"]`);
      }
      if(!imageSlide) return;
      let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
      if(quickShopSlider) quickShopSlider.slideTo(slideIndex, 2000, true);
      else if(productSlider)  productSlider.slideTo(slideIndex, 2000, true);
    }

    // Variant name update
    let options = this.form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let lableID = 'option'+option.dataset.optionindex;
      const lable = option.querySelector('.selected-option');
      if(!lable || !lableID) return;
      lable.innerHTML = currentVariant[lableID];
    });
  }

  updateProductPrice(currentVariant, container){
    if(!currentVariant || !container) return;
    const selectElement = container.querySelector('select[name="options[Size]"]') || this.querySelector('select[name="options[Size]"]');
    const selectedOption = selectElement ? selectElement.value : '';
    let priceElement = container.querySelector('[data-currentPrice]');
    const proCratePriceScript = document.querySelector('script[data-ProCrate]');
    if (proCratePriceScript){
      const parsedPrices = JSON.parse(proCratePriceScript.textContent);
      const match = parsedPrices.find(p => p.pro_crate_option == selectedOption);
      const selectedCrateType = document.querySelector('[data-crate-type]')?.value?.toLowerCase();
      if (selectedCrateType === 'platecrate pro' && match && match.pro_crate_price) {
        let formattedPrice = Shopify.formatMoney(match.pro_crate_price, window.globalVariables.money_format);
        if (priceElement) priceElement.innerHTML = formattedPrice;
      } else {
        let price = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format);
        if (priceElement) priceElement.innerHTML = price;
      }

    }
    else{
      let price = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format);
      if(priceElement) priceElement.innerHTML = price;
    }

    // Compare At Price Update
    let compare_price = Shopify.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
    let comparePriceElement = container.querySelector('[data-comparePrice]');

    if(comparePriceElement) {
      comparePriceElement.innerHTML = compare_price;
      if(currentVariant.compare_at_price <= 0){
        comparePriceElement.style.display = 'none';
      }else{
        comparePriceElement.style.display = 'block';
      }
    }
  }

  /**
   * Toggle the button based on product availability ( add to cart / soldOut )
   * @param {*} status enable / disable
   */
  toggleAddButton(status) {
    if (!this.addBtn) return;

    if (status == 'disable') {
      //  this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        // this.addBtn.querySelector('.add-text').textContent = window.variantStrings.unavailable;
        this.addBtn.removeAttribute('disabled');
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;

    } else if(this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;
    } else {
      this.addBtn.removeAttribute('disabled');
      if(this.form.classList.contains('cart-upsell-form')){
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.upsellAddText;
      }else{
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;
      }
    }
  }

  /**
   * Store the all the variants json
   */
  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}
  
  customElements.define('variant-selects', VariantSelects);
  
  /**
   * Radio Button swatch
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();

      this.form = this.closest('form') || this.querySelector('.form-element');
      this.formType = this.form.dataset.format;
      
      const colorSwatchContainer = this.querySelector('.color-swatch');
      if(colorSwatchContainer){
        const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
        colorSwatches.forEach(swatch => {
          let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
          let swatchStyle = Utility.getSwatchStyle(colorHandle);
          swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
        });
      }
    }
  }
  customElements.define('variant-radios', VariantRadios);